<template>
    <div class="container">
      <section v-if="verify" class="infoarea">
        <div class="item">
            <p class="label">企业名称</p>
            <p class="value">{{businessName}}</p>
        </div>
        <div class="item">
            <p class="label">营业执照注册号</p>
            <p class="value">{{creditCode}}</p>
        </div>
        <div class="item">
            <p class="label">法定代表人姓名</p>
            <p class="value">{{frName}}</p>
        </div>
        <div class="item">
            <p class="label">营业执照所在地</p>
            <p class="value">{{detailAddress}}</p>
        </div>
        <div class="item">
            <p class="label">企业注册资金</p>
            <p class="value">{{registeredCapital}}</p>
        </div>
        <div class="item">
            <p class="label">营业执照有效期</p>
            <p class="value">{{validDate}}</p>
        </div>
        <div class="item">
            <p class="label">营业执照经营范围</p>
            <p class="value">{{businessCategory}}</p>
        </div>
        <div class="item">
            <p class="label">营业执照照片</p>
            <div v-for="(item,index) in businessPics" :key="index" :style="{display:'inline-block'}">
              <img :src="item" @click="preview(businessPics)"/>
            </div>
            <p v-if="!businessPics.length">暂无数据</p>
        </div>
        <div class="item">
            <p class="label">许可证照片</p>
            <div v-for="(item,index) in bizPermitPicNews" :key="index" :style="{display:'inline-block'}">
              <img :src="item" @click="preview(bizPermitPicNews)"/>
            </div>
            <p v-if="!bizPermitPicNews.length">暂无数据</p>
        </div>
        <p class="tail">注：以上营业执照信息，根据国家工商总局《网络交易管理办法》要求对入驻商家营业执照信息进行公示，除企业名称
        通过认证外，其余信息由卖家自行申报填写。如需进一步核实，请联系当地工商行政管理部门。</p>
      </section>
      <section v-else class="message">
        <z-loading v-if="loading" type="zz" size="60px" vertical>正在加载</z-loading>
      </section>
    </div>
</template>
<script>
import Vue from 'vue'
import native from '@zz-common/native-adapter'
import { ImagePreview, Loading } from '@zz-common/zz-ui';
import { getBusinessInfoByType } from '../../../api/resourceApi'
import { queryParams } from '../../../lib/utils'
const query = queryParams()
Vue.use(ImagePreview)
export default {
  name: 'qualityInfo',
  components: {
    'z-loading': Loading
  },
  data() {
    return {
      uid: query.uid || this.$route.query.uid || '',
      businessName: '',
      creditCode: '',
      frName: '',
      detailAddress: '',
      registeredCapital: '',
      validDate: '',
      businessCategory: '',
      businessPic: [],
      bizPermitPicNew: [],
      verify: false,
      loading: false
    }
  },
  created() {
    native.setTitle({
      title: '资质信息'
    })
    native.registerSlider({ action: 501, type: 3, scenetype: 2002 }, this.callback)
  },
  computed: {
    businessPics() {
      return this.businessPic.map((item) => {
        return 'https://pic1.zhuanstatic.com/bizlicense/' + item
      })
    },
    bizPermitPicNews() {
      return this.bizPermitPicNew.map((item, _index) => {
        return 'https://pic1.zhuanstatic.com/bizlicense/' + item
      })
    }
  },
  methods: {
    async getData({ sessionId, successToken }) {
      const params = {
        sessionId,
        successToken,
        uid: this.uid,
        businessType: 'license',
        sourceCode: 'selfmain_page',
        type: '3'
      }
      const res = await getBusinessInfoByType(params)
      this.loading = false
      console.log(res)
      this.businessName = res.bizName || '-'
      this.creditCode = res.creditCode || '-'
      this.frName = res.frName || '-'
      this.detailAddress = res.detailAddress || '-'
      this.registeredCapital = res.registeredCapital || '-'
      this.validDate = JSON.parse(res.validDate).join('至') || '-'
      this.businessCategory = res.businessCategory || '-'
      this.businessPic = res.bizPic ? res.bizPic.split(',') : []
      this.bizPermitPicNew = res.bizPermitPicNew ? res.bizPermitPicNew.split(',') : []
      this.verify = true
    },
    preview(url) {
      ImagePreview(
        url
      )
    },
    async callback(params) {
      const { data: { sessionId, successToken } = {}, code } = params
      if (code == -3) {
        native.close()
      } else if (code == 0) {
        this.loading = true
        setTimeout(() => {
          this.getData({ sessionId, successToken })
        }, 1500);
      }
    }
  }
}
</script>

<style>
  .z-image-preview__image {
    pointer-events: none;
  }
</style>
<style lang="less" scoped>
  @import 'index.less';
</style>